module.exports = __webpack_public_path__ + "img/1536131601.bd5a8d10.jpg";